import React from 'react';

import { useDomFocus } from 'craft/hooks';

/**
 * We call all these hooks into sub-components because we want to makes sure
 * they don't impact the children and they don't re-renders
 */
const DomFocus = () => {
  useDomFocus();
  return null;
};

type RenderNodeProps = {
  children: React.ReactElement;
};

export const RenderNode: React.FC<RenderNodeProps> = React.memo(({ children }: RenderNodeProps) => {
  return (
    <>
      {children}
      <DomFocus />
    </>
  );
});
